import {useIsDesktop} from '@eCommerce/frontend-legacy-shared-library-native';
import {Flex, Text} from 'native-base';
import React, {MutableRefObject, useEffect, useRef} from 'react';
import {Animated, Easing} from 'react-native';
import Icon from 'react-native-vector-icons/FontAwesome5Pro';

interface SuccessFooterBannerProps {
  isSuccess: boolean;
  msg?: string;
  forwardRef?: MutableRefObject<any>;
  fadeOutDelay?: number;
  shouldAnimate?: boolean;
}

export const SuccessFooterBanner = (props: SuccessFooterBannerProps) => {
  const {
    isSuccess,
    msg = 'Updates saved.',
    forwardRef,
    fadeOutDelay = 3000,
    shouldAnimate = true,
  } = props;
  const isDesktop = useIsDesktop();
  const aniOpacityValue = useRef(new Animated.Value(1)).current;
  const aniHeightValue = useRef(new Animated.Value(70)).current;

  useEffect(() => {
    if (isSuccess && shouldAnimate) {
      Animated.sequence([
        Animated.timing(aniOpacityValue, {
          delay: fadeOutDelay,
          duration: 75,
          toValue: 0,
          useNativeDriver: false,
          easing: Easing.bezier(0.4, 0, 0.2, 1),
        }),
        Animated.timing(aniHeightValue, {
          duration: 250,
          toValue: 0,
          useNativeDriver: false,
          easing: Easing.bezier(0.4, 0, 1, 1),
        }),
      ]).start();
    } else {
      aniOpacityValue.setValue(1);
      aniHeightValue.setValue(70);
    }
  }, [aniHeightValue, aniOpacityValue, fadeOutDelay, isSuccess, shouldAnimate]);

  return !isSuccess ? null : (
    <Animated.View
      ref={forwardRef}
      style={{
        opacity: aniOpacityValue,
        maxHeight: shouldAnimate ? aniHeightValue : undefined,
        minHeight: shouldAnimate ? undefined : 70,
      }}>
      <Flex
        flex={1}
        flexDirection={'row'}
        alignItems={'center'}
        justifyContent={'center'}
        p={isDesktop ? 4 : 3}
        mt={isDesktop ? 0 : 5}
        backgroundColor={'#F8F8FA'}>
        <Icon
          name={'check-circle'}
          style={{
            fontSize: 19,
            color: '#3C763D',
          }}
        />
        <Text
          fontSize={2}
          fontFamily={'OpenSans-Bold'}
          color={'#3C763D'}
          ml={2}>
          {msg}
        </Text>
      </Flex>
    </Animated.View>
  );
};

export default SuccessFooterBanner;
